import React from 'react';
import { Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { categories } from '../../utils';
import { Title } from '@/components/Typography';
import { TaskRiskTablePropsDTO } from '../../types';
import * as S from './styles';

export function TaskRiskTable({ risk }: Readonly<TaskRiskTablePropsDTO>): JSX.Element {
	return (
		<S.StyledDivInformations>
			<Row justify="center" align="middle">
				{categories.map((cat) => (
					<S.StyledColHeader span={6} key={cat.category} className="border-left">
						<S.CategoryContainer>
							<S.ColorSquare color={cat.color} />
							<Title level={4} style={{ display: 'contents' }}>
								{I18n.get('Category')} {cat.category}
							</Title>
						</S.CategoryContainer>
					</S.StyledColHeader>
				))}
			</Row>

			<S.StyledLineRow justify="center" align="top">
				{risk?.map((item) => (
					<S.VerticalStyledCol span={6} key={item.score}>
						{item.codes?.map((code: any) => (
							<S.StyledScoreRow key={code.code}>
								<S.StyledScorColCode>{code.code}</S.StyledScorColCode>
								<S.StyledScorColFrequency>{code.frequency}x</S.StyledScorColFrequency>
							</S.StyledScoreRow>
						))}
					</S.VerticalStyledCol>
				))}
			</S.StyledLineRow>
		</S.StyledDivInformations>
	);
}
